import type { ColDef, ValueGetterParams } from 'ag-grid-community';

import type { Coefficient } from '@shared-types/coefficient.types';

export const tenYearsCols: ColDef[] = [
  {
    field: 'tcc',
    headerName: 'points',
    headerTooltip: 'total_club_coefficient',
    valueGetter: ({ data: c }: ValueGetterParams<Coefficient>) => c.overallRanking?.totalPoints,
    cellRenderer: ({ value }) => value?.toFixed(3) ?? '-',
    context: {
      getBold: (c: Coefficient) =>
        c.overallRanking && c.overallRanking?.totalPoints >= c.overallRanking?.nationalAssociationPoints,
    },
  },
  {
    field: 'ac',
    headerName: 'na_contr',
    headerTooltip: 'associtation_coefficient_info',
    valueGetter: ({ data: c }: ValueGetterParams<Coefficient>) => c.overallRanking?.nationalAssociationPoints,
    cellRenderer: ({ value }) => value?.toFixed(3) ?? '-',
    context: {
      getBold: (c: Coefficient) =>
        c.overallRanking && c.overallRanking.totalPoints < c.overallRanking?.nationalAssociationPoints,
    },
  },
];
